import React from 'react';
import { ModalContainer, ModalMixin } from '../components/layouts/modal-container';

import Dispatcher from '../dispatcher';

var Modals = {

  // globally show modals
  showModal: function(data, refocusDOM, parentElement){
    this.modalToShow = this.modalToShow || [];
    Fraction.Helpers.modalCloseRefocus = Fraction.Helpers.modalCloseRefocus || [];
    if (refocusDOM){
      Fraction.Helpers.modalCloseRefocus.push(refocusDOM);
    } else {
      // console.warn('Please include refocus element for this modal.');
    }
    if (!data.menuId){
      // console.warn('Please include a menu id');
    }
    this.modalToShow.push(<ModalContainer key={`modal-container-${data.menuId || data.title}`} {...data} modalCloseCallback={data.closeCallback || function(){}}  />);
    Dispatcher.emit(Dispatcher.MODAL_OPEN);
    if (Fraction.Helpers.modalRedraw){
      Fraction.Helpers.modalRedraw();
    }
    Fraction.Helpers.runAfterRender(function(){
      Fraction.Helpers.updateModalLocation(parentElement);
      $(".modal").focus();
    });
  },

  removeModal: function(callback, options){
    options = options || {};
    var parentModal;
    if (!parentModal){
      parentModal = $(".modal").last();
    }

    if (!parentModal.length) {
      // call callback and return
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    //this.modalCloseCallback();
    if (Fraction.Helpers.modalCloseRefocus && Fraction.Helpers.modalCloseRefocus.length>0){
      var refocus = Fraction.Helpers.modalCloseRefocus.pop();
      /*
      // Not really sure why we were ever doing this.
      // Next person who finds this should remove this block of code
      refocus.css("outline", "none").on("blur", function() {
        $(this).off("blur").css("outline", "");
      });
      */
      refocus.focus();
    }

    (function(callback){
      var fadeLength = options.fade || Fraction.Helpers.isSmallScreen() ? 0 : 100;
      parentModal.fadeOut(fadeLength, function(){
        if (Fraction.Helpers.modalToShow){
          Fraction.Helpers.modalToShow.pop();
          if (Fraction.Helpers.modalToShow.length === 0){
            Dispatcher.emit(Dispatcher.MODAL_CLOSE);
          }
        }
        if (Fraction.Helpers.modalRedraw){
          Fraction.Helpers.modalRedraw();
        }
        if (callback && (typeof callback)==="function"){
          callback();
        }
      });
    })(callback);
  },

  // Update modal location
  updateModalLocation: function(modalElement){
    if (Fraction.Helpers.modalToShow){
      $(".modal").each(function(){
        if ($(this).hasClass("ignore-position")){return;}
        var fadeLength = Fraction.Helpers.isSmallScreen() ? 0 : 200;
        $(this).fadeIn(fadeLength, function(){});
        if (modalElement){
          $(this).css('width', 'auto');
          $(this).css('height', 'auto');
          $(this).find('.modal-title').css('font-size', '2.0rem');
          $(this).find('.modal-title').css('text-align', 'center');
          $(this).css('position', 'absolute');
          $(this).css('top', $(modalElement).offset().top+12);
          $(this).css('left', $(modalElement).offset().left+12);
          $(this).css('bottom', $(window).height()-($(modalElement).offset().top+$(modalElement).outerHeight(true))+12);
          $(this).css('right', $(window).width()-($(modalElement).offset().left+$(modalElement).outerWidth(true))+12);
        } else {

          if (!Fraction.Helpers.isSmallScreen()){
            var newTop = ($(document).height()/2.0)-($(this).height()/2)-40;
            var newLeft = ($(document).width()/2.0)-($(this).width()/2);

            // Taller modals might go out of bounds, so set a min value for this
            if (newTop < 10) {
              newTop = 10;
            }
            // If fixed top is set, use that
            if ($(this).attr("data-fixed-top")) {
              newTop = $(this).attr("data-fixed-top") + "px";
            }
            // If fixed left is set, use that
            if ($(this).attr("data-fixed-left")) {
              newLeft = $(this).attr("data-fixed-left") + "px";
            }

            $(this).css('top', newTop);
            $(this).css('left', newLeft);
          }
        }
      });
    }
  },

  isModalOpen: function() {
    return Fraction.Helpers.modalToShow && Fraction.Helpers.modalToShow.length > 0;
  },

  toast: function(text, options){
    $(".toast").remove();
    if (!options) { options = {}; }
    if (!options.side) { options.side = "top"; }
    // still need to add direction, and container stuff, etc
    if (!options){ options={}; }
    var toastText = $("<span>"+text+"</span>");
    options.type = options.type || "notice"; // other option right now is 'error'
    var toast = $("<div role='alert' class='toast "+options.type+"'></div>").append(toastText);
    if (options.dismissable){
      var closeToast = $("<button class='close-toast noButton'></button>");
      closeToast.on('click', function(){
        toast.fadeOut();
      });
      toastText.append(closeToast);
    }
    if (options.parentElement){
      toast.css(options.side, options.parentElement.offset().top+12);
    } else {
      toast.css(options.side, -80);
    }
    $("body").append(toast);
    toast.fadeIn();
    options.distance =  options.distance || 24;
    if (options.centered){
      options.distance = $(window).height()/2-58; // just a bit above center
      toast.css(options.side, options.distance);
    }

    var animateDuration = 300;
    if (options.animate === false) {
      animateDuration = 0;
    }

    if (options.side==="bottom"){
      toast.animate({
        bottom: options.distance
      }, animateDuration);
    } else {
      toast.animate({
        top: options.distance
      }, animateDuration);
    }
    if (!options.dismissable){
      setTimeout(function(){
        toast.fadeOut();
      }, options.timeout || 4000);
    }
  }

};

module.exports = Modals;
